var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViolet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3032",
    width: 73,
    height: 73,
    rx: 6.9,
    fill: "#8042F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3317 44.0925L49.3003 36.0057C49.268 33.1176 48.2439 30.4692 46.5623 28.3984L24.5938 36.4744C24.6261 39.3625 25.6501 42.0218 27.3317 44.0925Z",
    fill: "url(#paint0_linear_359_47904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.7855 59.4814C45.021 59.4814 52.2432 55.0892 56.2748 48.4955L46.8427 42.9917C44.6868 46.294 40.9895 48.4846 36.7747 48.4846C33.0234 48.4846 29.671 46.7517 27.4612 44.0271L16.9297 47.8961C17.0051 48.016 17.0698 48.1468 17.1345 48.2667C21.166 54.9912 28.4529 59.4814 36.7855 59.4814Z",
    fill: "url(#paint1_linear_359_47904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.7863 13.1396C24.1312 13.1396 13.8691 23.5152 13.8691 36.3103C13.8691 40.2883 14.8393 43.9829 16.5856 47.2525L17.2216 48.386L27.7962 44.4189L27.1387 43.5688C25.6403 41.5416 24.7564 39.0349 24.7564 36.3103C24.7564 29.5858 30.1461 24.1364 36.7971 24.1364C43.4049 24.1364 48.7623 29.5095 48.8378 36.1795L59.3801 32.3213C57.4937 21.4227 48.094 13.1396 36.7863 13.1396Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_47904",
    x1: 21.6629,
    y1: 42.4836,
    x2: 42.073,
    y2: 34.3347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_47904",
    x1: 45.2634,
    y1: 39.1481,
    x2: 34.2507,
    y2: 50.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolet);
export default __webpack_public_path__ + "static/media/violet.7cb287184802bef3a7097c78a0ed8260.svg";
export { ForwardRef as ReactComponent };